import { Button, Modal, Typography } from 'antd'
import { UploadFile } from 'antd/es/upload/interface'
import React, { FC, useState } from 'react'
import { getAcceptFormats } from '../../../../../utils/getAcceptFormat'
import { Switch, Upload } from '../../../../common'
import './../competence-docs.ant.scss'
import styles from './competence-docs-modal.module.scss'
import { Text } from '../../../../common/text'

type PropsCompetenceDocsModal = {
  visibleForm: boolean
  onCloseForm: () => void
  onSaveForm: (files: UploadFile[], notification?: boolean) => void
}

const CompetenceDocsAddDocModal: FC<PropsCompetenceDocsModal> = (props) => {
  const { visibleForm, onCloseForm } = props

  const [files, setFiles] = useState<UploadFile[]>([])
  const [notification, setNotification] = useState<boolean>(true)

  const onSave = () => {
    if (!props.onSaveForm) return

    props.onSaveForm(files, notification)
    onClose()
  }

  const onClose = () => {
    onCloseForm()
    setFiles([])
    setNotification(true)
  }

  const handleUploadFileAdd = (fileList: UploadFile[]) => {
    setFiles([...fileList])
  }

  const handleRemove = (uid: string) => {
    setFiles(files.filter((file) => file.uid !== uid))
  }

  return (
    <Modal
      visible={visibleForm}
      onCancel={onClose}
      destroyOnClose={true}
      maskClosable={true}
      footer={null}
      className={styles.modal}
    >
      <header>
        <Typography.Title level={4}>Загрузить документ</Typography.Title>
      </header>
      <Upload
        files={files}
        onUploadFileAdd={handleUploadFileAdd}
        onRemoveFile={handleRemove}
        tooltipDescription={'Допустимые форматы файлов: ' + getAcceptFormats('file')}
        withoutVideo={true}
        formatFiles="file"
      />
      <div className={styles.notificationsConfig}>
        <Text className={styles.notificationsTitle}>Уведомления о загрузке новых документов</Text>
        <Text size={'sm'} className={styles.notificationsSubtitle}>
          Приходят на электронную почту участников компетенции
        </Text>
        <label>
          <Switch checked={notification} onClick={() => setNotification((pre) => !pre)} />
          <Text>Отправлять уведомления</Text>
        </label>
      </div>
      <footer>
        <Button type={'ghost'} onClick={onSave}>
          Сохранить
        </Button>
        <Button onClick={onClose}>Отменить</Button>
      </footer>
    </Modal>
  )
}

export default CompetenceDocsAddDocModal
